import type { CurrentUser } from "@/modules/user/userActions";
import { relationTypes } from "./relationTypes";
import { TicketFormValues } from "./TicketForm";
import { TicketFormBody } from "@/modules/ticket/ticketForm/ticketFormOperations";

const formatTicketBody = (body, place) => {
  const trimmedBody = body?.trim();
  const trimmedPlace = place?.trim();

  if (!trimmedBody && !trimmedPlace) {
    return "";
  }

  if (!trimmedPlace) {
    return trimmedBody ?? "";
  }

  if (!trimmedBody) {
    return `---\n${trimmedPlace}`;
  }

  return `${trimmedBody}\n---\n${trimmedPlace}`;
};
export const buildTicketPayload = (
  values: TicketFormValues,
  currentUser: CurrentUser,
): TicketFormBody => {
  const { estateId, subject, body, place, serviceType, capture, anonymous } =
    values;

  const ticket: TicketFormBody = {
    estateId: estateId!,
    subject: subject,
    body: formatTicketBody(body, place),
    messagesEnabled: true,
    anonymous,
  };

  // Configure access based on privacy setting
  if (values.private) {
    ticket.accessibleByPersonIds = currentUser?.id ? [currentUser.id] : [];
    ticket.publishingMode = "UNPUBLISHED";
    ticket.accessibleByTypes = [];
  } else {
    ticket.accessibleByTypes = relationTypes.map(({ id }) => id);
    ticket.publishingMode = "PUBLISHED";
    ticket.accessibleByPersonIds = [];
  }

  // Set living unit IDs for anonymous tickets
  if (values.anonymous && currentUser?.relations) {
    const livingUnitIds = currentUser.relations
      .filter((estate) => estateId === estate.estateId)
      .map(({ livingUnitId }) => livingUnitId)
      .filter((id): id is number => id !== undefined);
    ticket.livingUnitIds = livingUnitIds;
  }

  // Add service type if selected
  if (serviceType) {
    ticket.serviceType = { id: serviceType };
  }

  // Add attachments
  ticket.attachments = capture;

  return ticket;
};
